<div
  class="appointment-carousel-container"
  data-test="appointment-carousel-container"
>
  <p-carousel
    [value]="appointmentCarouselDates"
    [numVisible]="numVisible"
    [numScroll]="numVisible"
    [showIndicators]="false"
    [showNavigators]="appointmentCarouselDates.length > numVisible"
    (onPage)="onCarouselPage($any($event))"
    #carousel
  >
    <ng-template
      let-apptCarouselDate
      pTemplate="item"
    >
      <div class="carousel-tile-wrapper">
        <div
          class="carousel-date-tile carousel-tile"
          data-test="carousel-date-tile"
        >
          <span class="carousel-date">
            <span class="date-row">{{ apptCarouselDate.date | date:'EEE' }}</span>
            <span class="date-row">{{ apptCarouselDate.date | date:'MMM d' }}</span>
          </span>
        </div>
        <button
          class="carousel-time carousel-tile"
          data-test="time-slot"
          [class.selected-time]="selectedTime === timeSlot.utcStartTime"
          [ariaPressed]="selectedTime === timeSlot.utcStartTime"
          [ariaLabel]="'session slot at ' + (timeSlot.displayStartTime | date:'h:mm aa') + ' on ' + (apptCarouselDate.date | date:'EEEE, MMMM d')"
          [id]="createSlotId(timeSlot.utcStartTime, apptCarouselDate.date)"
          *ngFor="let timeSlot of apptCarouselDate.showAllAppointments
            ? apptCarouselDate.appointments
            : apptCarouselDate.appointments.slice(0, initialNumTimesPerDate)"
          (click)="clickAppointmentTime($event, timeSlot.utcStartTime, timeSlot.utcEndTime, apptCarouselDate)"
          (focus)="updateCarouselPage(apptCarouselDate, timeSlot.utcStartTime)"
          (keydown)="handleSlotKeydown($event, timeSlot, apptCarouselDate)"
          type="button"
        >
          {{ timeSlot.displayStartTime | date:'h:mm aa' | lowercase }}
        </button>
        <button
          *ngIf="apptCarouselDate.appointments.length > initialNumTimesPerDate && !apptCarouselDate.showAllAppointments"
          class="more-times"
          [id]="createMoreButtonId(apptCarouselDate.date)"
          [ariaLabel]="'show more times on ' + (apptCarouselDate.date | date:'EEEE, MMMM d')"
          (click)="seeMoreTimes(apptCarouselDate)"
          (keydown)="handleMoreButtonKeydown($event, apptCarouselDate)"
          type="button"
          data-test="more-times"
        >
          more
        </button>
      </div>
    </ng-template>
  </p-carousel>
</div>